"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelContainer = void 0;
var _mui = require("@ori-ui/mui");
const LabelContainer = exports.LabelContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  marginBottom: theme.spacing(1),
  ...(theme.responsiveLayout && {
    [theme.breakpoints.up('md')]: {
      marginBottom: 0
    }
  })
}));
//# sourceMappingURL=styles.js.map